import { useState, useEffect } from 'react';
import { api } from '../api';

// Decode JWT payload (handles standard base64url encoding)
const decodeToken = (token) => {
  try {
    const parts = token.split('.');
    if (parts.length === 3) {
      // Standard JWT: decode the payload (part 2, base64url encoded)
      const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
      const pad = base64.length % 4;
      const padded = pad ? base64 + '='.repeat(4 - pad) : base64;
      return JSON.parse(atob(padded));
    }
    // Legacy simple base64 token
    return JSON.parse(atob(token));
  } catch {
    return null;
  }
};

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('ako_token');
    if (token) {
      const decoded = decodeToken(token);
      if (decoded) {
        setUser({ ...decoded, avatar: decoded.role === 'admin' ? '👑' : '👤' });
      } else {
        localStorage.removeItem('ako_token');
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const data = await api.login(email, password);
    if (data.twofa_required) {
      return { success: false, twofa_required: true, temp_token: data.temp_token };
    }
    if (data.token) {
      localStorage.setItem('ako_token', data.token);
      // Prefer decoded JWT payload, fallback to data.user from response
      const decoded = decodeToken(data.token);
      const userData = decoded || data.user || {};
      setUser({ ...userData, avatar: userData.role === 'admin' ? '👑' : '👤' });
      return { success: true };
    }
    return { success: false, error: data.error || 'Email ou mot de passe incorrect' };
  };

  const loginWithToken = (token, userData) => {
    localStorage.setItem('ako_token', token);
    const decoded = decodeToken(token);
    const user = decoded || userData || {};
    setUser({ ...user, avatar: user.role === 'admin' ? '👑' : '👤' });
    return { success: true };
  };

  const register = async (name, email, password, phone, metier) => {
    const data = await api.register(name, email, password, phone, metier);
    if (data.token) {
      localStorage.setItem('ako_token', data.token);
      const decoded = decodeToken(data.token);
      const userData = decoded || data.user || {};
      setUser({ ...userData, avatar: '👤' });
      return { success: true };
    }
    return { success: false, error: data.error || "Erreur lors de l'inscription" };
  };

  const logout = () => {
    localStorage.removeItem('ako_token');
    setUser(null);
  };

  return { user, loading, login, loginWithToken, register, logout };
};
